import React from "react";
import { CSSTransition } from "react-transition-group";
import PropTypes from 'prop-types';
import SVGElements from 'root/components/SVGElements';

export default class SortItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = { in: false };
  }

  componentDidMount() {
    this.initEvent();
  }

  initEvent() {
    document.querySelector("#root").addEventListener("click", (e) => {
      if (this.state.in) {
        let stopEventEl = [
          (this.refs.el).querySelector(".sort-select"),
          (this.refs.el).querySelector(".spread"),
        ];
        for (let index = 0; index < stopEventEl.length; index++) {
          let child = stopEventEl[index];
          child = child && child.$el ? child.$el : child;
          if (child && child.contains(e.target)) return;
        }

        this.onShow();
      }
    });
  }

  onShow() {
    this.setState((state) => ({
      in: !state.in,
    }));
  }

  render() {
    const {
      handleDropDownChange
    } = this.props.slotsFunction;
    
    return (
      <div ref="el" className={["sort-item", this.state.in ? "active" : null].join(" ")}>
        <div>{this.props.title}</div>
        <div className="sort-select" onClick={() => this.onShow()}>
          {/* <div> 整体作为点击区域*/}
          <span>{this.props.value}</span>
          <CSSTransition
            className="spread"
            classNames="spread"
            in={this.state.in}
            timeout={300}
            unmountOnExit
          >
            <ul>
              {this.props.items.map((item, i) => (
                <li key={i} onClick={() => handleDropDownChange(item, this.props.sortName)}>{item.toString()}</li>
              ))}
            </ul>
          </CSSTransition>
          <CSSTransition
            classNames="rotate180"
            in={this.state.in}
            timeout={300}
          >
            <SVGElements className="icon-arrow-down2" name='arrow-down-icon' />
            {/* <i className="icon-arrow-down2"></i> */}
          </CSSTransition>
          {/* </div> */}
        </div>
      </div>
    );
  }
}

SortItem.propTypes = {
  slotsFunction: PropTypes.object.isRequired,
};